import GiantExplorer from './giant-explorer';

export default GiantExplorer;
